import { createIcon } from '@chakra-ui/react';

export const R3PortalIcon = createIcon({
  viewBox: '0 0 28 28',
  displayName: 'R3PortalIcon',
  path: (
    <>
      <path d="M4 7.47511C4 5.55586 5.45862 4 7.25792 4H13V13.6H4V7.47511Z" fill="#31C9B3" />
      <path d="M15.6562 4H22.4062C23.6489 4 24.6562 5.07452 24.6562 6.4V13.6H15.6562V4Z" fill="#08AC96" />
      <path d="M4 16.4333H13V26.0334H6.25C5.00736 26.0334 4 24.9589 4 23.6333V16.4333Z" fill="#2E615A" />
      <path
        d="M18.6108 26.7598C18.6531 26.6753 18.7641 26.4836 19.0654 25.4066C19.2134 24.8821 19.3139 24.1378 19.4037 23.3595C19.5571 22.0739 19.6734 21.5382 19.8214 21.1039C19.8478 21.025 19.795 20.9404 19.7104 20.9404C19.2081 20.9517 18.3253 20.9066 17.7068 20.5739C16.8186 20.0946 15.0053 18.9273 14.0432 18.8258C14.0009 18.8202 13.985 18.7638 14.0167 18.7356C14.3762 18.386 14.6829 18.2563 15.2961 18.1322C16.9666 17.8052 18.7641 18.1266 20.1809 18.6116C21.1747 18.9498 21.5712 19.2205 21.6928 18.6735C21.7827 18.2676 21.8726 16.6661 23.1519 16.621C23.8075 16.5983 24.0771 16.7169 24.1405 16.7507C25.182 16.4799 26.9212 15.854 27.7829 15.7413C28.0578 15.7018 28.079 15.8202 27.8041 15.8823C27.5292 15.9386 25.4727 16.5138 24.6322 17.1172C23.9608 17.5965 23.6647 18.713 23.6013 19.2826C23.4955 20.2073 23.3475 21.713 21.1007 23.681C20.5139 24.1941 19.3139 25.7674 18.9755 26.5061C18.6372 27.2449 18.3993 27.1546 18.6108 26.7598Z"
        fill="#249484"
      />
    </>
  ),
});
